<script setup lang="ts">
    import { Swiper, SwiperSlide } from 'swiper/vue';
    import { Pagination } from 'swiper/modules';
    import type { Asset } from '~/@types/cms';
    import 'swiper/css';
    import 'swiper/css/pagination';

    declare interface ProductImageProps {
        images: Asset[];
        type?: string;
        isBike: boolean;
    }

    const props = defineProps<ProductImageProps>();

    const { setMainSwiper } = useGallery();

    const images = computed(() => {
        if (!props.images) return [];
        return props.images
            .map((image: Asset) => {
                if (!image) return;
                if (typeof image === 'string') {
                    return image;
                }
                if (isAssetBynder(image)) {
                    return `${image.data.baseUrl ?? ''}${props.isBike ? image.data['3to2'] : image.data['1to1'] ? image.data['1to1'] : image.data.image}`;
                } else if (isAssetKontentAi(image)) {
                    return image.data.src;
                } else {
                    // console.log('other asset', a);
                }
            })
            .filter(isDefined);
    });
</script>
<template>
    <div class="mol-product-image col-span-6 col-start-3 hidden auto-cols-auto lg:grid">
        <atm-grid no-margin>
            <template
                v-for="(asset, index) in images"
                :key="index">
                <template v-if="$slots.default && index === 0">
                    <slot></slot>
                </template>
                <atm-image
                    :src="asset"
                    sizes="100vw md:1024px lg:1264px"
                    :class="[(index === 0 && !props.isBike) || props.isBike ? 'col-span-12 mx-auto' : 'col-span-6']" />
            </template>
        </atm-grid>
    </div>
    <div class="mol-product-image relative col-span-2 md:col-span-12 lg:hidden">
        <nuxt-error-boundary @error="() => {}">
            <swiper
                :modules="[Pagination]"
                :scrollbar="{ draggable: true, el: '.swiper-scrollbar' }"
                :centered-slides="true"
                loop
                :slides-per-view="'auto'"
                :pagination="{
                    clickable: true,
                    dynamicBullets: false,
                }"
                :looped-slides="1"
                @swiper="setMainSwiper">
                <swiper-slide
                    v-for="(asset, index) in images"
                    :key="asset">
                    <template v-if="$slots.default && index === 0">
                        <slot></slot>
                    </template>
                    <atm-image
                        :data="asset"
                        sizes="100vw md:1024px" />
                </swiper-slide>
            </swiper>
        </nuxt-error-boundary>
    </div>
</template>
<style scoped>
    :deep(.swiper-pagination-bullet-active) {
        @apply bg-woom-black;
    }
</style>
